import { useState } from "react";
import { Card, CardContent, Link, Switch, Typography } from "@mui/material";
import {
  Automation,
  automationsService,
  AutomationStatus,
} from "services/admin/automationsService";
import { NavLink, Link as RouterLink } from "react-router-dom";
import { fromNow } from "helpers/dateHelper";
import { toast } from "react-toastify";

export const AutomationCard = ({ automation }: { automation: Automation }) => {
  // Статус храним локально: если сервер откажет (например, кодовое слово занято), переключатель не сдвинется
  const [isActive, setIsActive] = useState(automation?.status === AutomationStatus.ACTIVE);

  if (!automation) {
    return null;
  }

  const handleChangeStatus = async () => {
    const nextStatus = isActive ? AutomationStatus.INACTIVE : AutomationStatus.ACTIVE;
    try {
      await automationsService.updateAutomation(automation.id, { status: nextStatus });
      setIsActive(nextStatus === AutomationStatus.ACTIVE);
      toast.success("Статус автоматизации успешно обновлен");
    } catch (error) {
      // Текст ошибки с сервера уже показан (интерцептор axios), переключатель остаётся как был
      console.error("Error updating automation status", error);
    }
  };
  return (
    <div>
      <Card>
        <CardContent>
          <div className="flex">
            <div className="flex" style={{ flex: 0.4 }}>
              <Switch
                size="small"
                checked={isActive}
                onChange={handleChangeStatus}
              />
              <NavLink
                to={`/admin/ai-agents/${automation.agentID}/automations/flow/${automation.id}`}
              >
                <div className="text-lg font-bold ml-4 cursor-pointer">{automation.name}</div>
              </NavLink>
            </div>
            <div className="flex justify-end items-center text-sm gap-4" style={{ flex: 0.6 }}>
              <div>38 запусков</div>
              <div>20 CTR %</div>
              <div>{fromNow(automation.updatedAt)}</div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
